import * as types from 'actions/actionTypes';
import initialState from './initialState';

/**
 * reducer per gestire le interrogazioni a crashboxx/services/icnplus/speeddata
 * @param {*} state
 * @param {*} action
 */
export default function icnSpeedReducer(state = initialState.icnSpeedSearch, action){

    switch(action.type)
    {
        case types.GET_ICNSPEED_REQUEST:
            return {...state, list: [], item: null, error: null, isSearching: true};
        case types.GET_ICNSPEED_SUCCESS:
            return {...state, list: action.data.speeddetailsdata.speeddetails, error: null, isSearching: false};
        case types.GET_ICNSPEED_ERROR:
            return {...state, list: [], error: action.data, isSearching: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/icnSpeedReducer.js